<template>
  <section v-maximizable>
    <div class="table-tab" id="table-tab">
      <div class="table-tab__container" tabindex="1" style="overflow: hidden; outline: none;">
        <table class="table-tab__block table " style="min-width: 1300px">
          <thead class="table-tab__thead">
          <tr class="table-tab__height-auto-column-header" style="height: 48px;">
            <th style="width:150px">{{$t('form.black-box.time')}}</th>
            <th style="width:200px">{{$t('form.black-box.user')}}</th>
            <th>{{$t('form.black-box.data')}}/{{$t('form.black-box.reply')}}</th>
          </tr>
          </thead>
          <tbody class="table-tab__tbody">
          <tr class="table-tab__height-auto-column-body table-tab__tr-border" v-for="item in items">
            <td><date-time class="a-input a-input--disabled" :value="item.time" ></date-time></td>
            <td>{{item.userId}}</td>
            <td><div class="column_data">{{item.data}}</div>
                <div class="column_reply">{{item.reply}}</div></td>

          </tr>
          </tbody>
        </table>
      </div>
      <div class="table-tab__nav">
        <nav>
          <ul class="pagination">
            <li class="page-item prev">
              <span class="page-link" @click="onPrevPageClick">
                <img src="@/assets/img/static/arrow-next-prev.png" alt="">
              </span>
            </li>

            <li class="page-item" :class="{'active': p.active, 'disabled': p.disabled}" v-for="p in pages">
              <span class="page-link" @click="onPageClick(p)">{{p.label}}</span>
            </li>

            <li class="page-item next">
              <span class="page-link" @click="onNextPageClick">
                <img src="@/assets/img/static/arrow-next-prev.png" alt="">
              </span>
            </li>
          </ul>
        </nav>

        <div class="admin-buy__show-item">
          <p>{{$t('labels.show-by')}}</p>
          <dropdown-new class="select-w-77" v-model="pageSize">
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="50">50</option>
          </dropdown-new>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import _ from 'lodash'

  export default {
    data: () => ({
      pageSize: 10,
      page: 1,
    }),

    computed: {
      totalPages() {
        return Math.ceil(this.$store.getters.blackBox.total / this.pageSize) || 0;
      },

      pages() {
        const minPage = Math.max(1, this.page - 4);
        const maxPage = Math.min(minPage + 10, this.totalPages);
        const pages = [];

        for (let id = minPage; id <= maxPage; ++id) {
          if (id === minPage && minPage !== 1) {
            pages.push({
              disabled: true,
              label: '...'
            });
          }
          else if (id === maxPage && maxPage !== this.totalPages) {
            pages.push({
              disabled: true,
              label: '...'
            });
          }
          else {
            pages.push({
              active: id === this.page,
              id: id,
              label: id
            })
          }
        }

        return pages;
      },

      items() {
        return this.$store.getters.blackBox.items;
      }
    },

    watch: {
      pageSize() {
        this.page = 1;
        this.fetchBlackBox();
      }
    },

    async created() {
      this.fetchBlackBox();
    },

    methods: {
      async fetchBlackBox() {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('fetchBlackBox', {
              page: this.page,
              pageSize: this.pageSize
            });
          }
          catch(e) {
            console.error('unable to fetch list from blackBox', e);
            this.globalErrorHandler(e);
          }
        });
      },

      onPrevPageClick() {
        if (this.page > 1) {
          --this.page;
          this.fetchBlackBox();
        }
      },

      onNextPageClick() {
        if (this.page < this.totalPages) {
          ++this.page;
          this.fetchBlackBox();
        }
      },

      onPageClick(page) {
        if (!page.disabled && !page.active) {
          this.page = page.id;
          this.fetchBlackBox();
        }
      },
    }
  }
</script>

<style scoped>
  .page-link {
    cursor: pointer;

  }
  .column_reply
  {
    margin-top: 15px
  }

</style>
